import { absoluteUrl } from "../seo/siteUrl";

/**
 * JSON-LD BreadcrumbList (https://schema.org/BreadcrumbList).
 * @param {{ name: string, path?: string }[]} items — first item is usually Home
 */
export function buildBreadcrumbListJsonLd(items) {
  if (!items?.length) return null;
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.name,
      item: item.path ? absoluteUrl(item.path) : undefined,
    })),
  };
}
